import React from 'react'

import PageLayout from '@layout/PageLayout'
import { SearchCategory } from '@services/SearchService'

const searchConfig = Object.freeze({
  [SearchCategory.SCORE]: 6,
  [SearchCategory.GROUP]: 6,
  [SearchCategory.TITLE]: 2,
  [SearchCategory.COMMUNITY_MEMBER]: 4,
})

const CommunitiesPage: React.FC = () => {
  return <PageLayout searchConfig={searchConfig} />
}

export default CommunitiesPage
